module.exports = __webpack_public_path__ + "AvenirNextLTPro-Light.75c299bf61ee68da44e1.otf";


//////////////////
// WEBPACK FOOTER
// ./src/app/content/fonts/AvenirNextLTPro-Light.otf
// module id = 179
// module chunks = 1